
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { Question } from '../../../../types/contentContract';

@Component({})
export default class IAElementComponent extends Vue {
  isValidated: boolean = false;
  answers: Array<any> = [];
  activeIndex: number = 0;
  activeValue: string = '';
  buttonLabelControl = 'Kontroller dine svar';
  buttonLabelRemove = 'Nulstil';

  get questions(): Array<Question> {
    return this.$props.template.data.questions;
  }

  get uid(): string {
    return this.$props.template.data.uid;
  }

  get labels(): string {
    return this.$props.template.data.labels;
  }

  get correct(): string {
    return this.$props.template.data.positive;
  }

  get incorrect(): string {
    return this.$props.template.data.negative;
  }

  get randomAnswers(): Array<string> {
    return this.$props.template.data.randomAnswers;
  }

  get headers(): string {
    return this.$props.template.data.headers;
  }

  IndexOfResponse(index: number): number {
    return this.answers.findIndex((obj) => {
      return obj.id === index;
    });
  }

  answerResponse(answer: string, index: number): boolean {
    if (!this.answers.length) {
      return false;
    }

    const isValid = this.answers.some(
      (answerObj: { answer: string; id: number; isValidated: boolean }) => {
        return answerObj.answer === answer.toString() && index === answerObj.id;
      }
    );

    return isValid;
  }

  chooseAnswer(answer: string, index: number): void {
    this.activeValue = answer;
    this.activeIndex = index;

    const obj: { answer: string; id: number; isValidated: boolean } = {
      answer,
      id: this.activeIndex,
      isValidated: false
    };
    if (!this.answers.some((event) => event.id === this.activeIndex)) {
      this.answers.push(obj);
    } else {
      // Array needs to find the object that contains the active index already, so it knows what to change.
      this.answers[this.answers.findIndex((el) => el.id === this.activeIndex)] =
        obj;
      this.answers.push();
    }
  }

  validateAnswers(): void {
    if (this.answers.length) {
      this.answers.forEach(function (cell) {
        cell.isValidated = true;
      });
      this.answers.push();
      this.isValidated = true;
    }
  }
}
